const prefix = 'WE_WANT_TO_PAY';

export const MODAL_DELAY_AFTER_ACTION = 5000;
export const MODAL_DELAY = 1000 * 60 * 60; // one hour

export const MODAL_NAME = 'payout-billing-details-modal';

export const STORAGE_KEY = 'we_want_to_pay_modal_last_shown';
export const BILLING_INFO_STORAGE_KEY = 'billing_information';
export const SHOW_WE_WANT_TO_PAY_STORAGE_KEY = 'we_want_to_pay_show';

export const Actions = {
  OPEN: `${prefix}/OPEN_MODAL`,
  CLOSE: `${prefix}/CLOSE_MODAL`,
};
